/**
 * @format
 */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreatePaymentRequest, CreatePaymentResponse, OtmId } from 'common-typescript/types';
import { Observable } from 'rxjs';
import { DowngradedService, ServiceDowngradeMappings, StaticMembers } from 'sis-common';

const CONFIG = {
    ENDPOINTS: {
        backend: '/ori/api',
        createPayment() {
            return `${this.backend}/study-right-extension/payment-system/create-payment`;
        },
        getIsActiveAndPaid(workflowId: OtmId) {
            return `${this.backend}/study-right-extension/active-and-paid/${workflowId}`;
        },
    },
};

@StaticMembers<DowngradedService>()
@Injectable({ providedIn: 'root' })
export class StudyRightExtensionPaymentService {
    constructor(private http: HttpClient) {}

    static readonly downgrade: ServiceDowngradeMappings = {
        dependencies: [],
        moduleName: 'sis-components.service.studyRightExtensionPaymentService',
        serviceName: 'studyRightExtensionPaymentService',
    };

    /**
     * Creates a new `StudyRightExtensionPayment` and starts a payment process with an external payment system.
     * Also creates a `StudyRightExtensionWorkflow` with DRAFT documentState and WAITING_FOR_PAYMENT workflowState.
     * Returns a payment URL where the user should be directed to complete the payment.
     * @param createPaymentRequest
     */
    createPayment(createPaymentRequest: CreatePaymentRequest): Observable<CreatePaymentResponse> {
        return this.http.post<CreatePaymentResponse>(CONFIG.ENDPOINTS.createPayment(), { ...createPaymentRequest });
    }

    getIsActiveAndPaid(workflowId: OtmId): Observable<boolean> {
        return this.http.get<boolean>(CONFIG.ENDPOINTS.getIsActiveAndPaid(workflowId));
    }
}
